import { IMemberTypes } from 'components/Collectives/Demo/common'
import { useCollectiveDemoContext } from 'context/CollectiveDemoContext'
import { useCallback } from 'react'

export const useSignProposal = () => {
  const {
    collectiveDemo,
    currentUser,
    getProposalDataForId,
    setProposalDataForId
  } = useCollectiveDemoContext()

  const signProposal = useCallback(
    (id: string, signator: IMemberTypes = currentUser) => {
      if (!collectiveDemo) {
        return
      }

      const proposal = getProposalDataForId(id)

      if (!proposal) {
        return
      }

      const newProposal = { ...proposal }

      if (!newProposal.proposal) {
        return
      }

      newProposal.proposal.signatures = [
        ...newProposal.proposal.signatures,
        {
          __typename: 'CollectiveProposalSignature',
          createdAt: new Date(),
          id: 'randomId',
          signature: 'randomSig',
          user: signator.membership.user,
          valid: true
        }
      ]

      setProposalDataForId(id, newProposal)

      return newProposal
    },
    [collectiveDemo, currentUser, getProposalDataForId, setProposalDataForId]
  )

  return signProposal
}
